
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useProfileData } from '@/hooks/useProfileData';
import ProfileAvatar from './ProfileAvatar';
import ProfileForm from './ProfileForm';

const ProfileInfoTab = () => {
  const { 
    form, 
    onSubmit, 
    isLoading, 
    error, 
    userInitials, 
    userId, 
    avatarUrl, 
    onAvatarUpdate 
  } = useProfileData();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Profilinformation</CardTitle>
        <CardDescription>
          Uppdatera dina personuppgifter och kontaktinformation
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-8">
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          
          <ProfileAvatar 
            userInitials={userInitials} 
            avatarUrl={avatarUrl}
            userId={userId}
            onAvatarUpdate={onAvatarUpdate}
          />
          
          <ProfileForm 
            form={form} 
            onSubmit={onSubmit} 
            isLoading={isLoading} 
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileInfoTab;
